export function getFileName(contentDisposition: string | undefined): string {
  if (!contentDisposition) return "arquivo-desconhecido";

  // tenta UTF-8
  const utf8Match = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1]);

  // fallback ASCII
  const asciiMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (asciiMatch?.[1]) return asciiMatch[1];

  return "arquivo-desconhecido";
}
